import { createAsyncThunk } from '@reduxjs/toolkit';
import { IPagination } from 'src/requests/BaseRequest';
import rf from 'src/requests/RequestFactory';

export interface ICreateCommunityParams {
  id?: number;
  name: string;
}

export interface ICommunity {
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export const createCommunity = createAsyncThunk(
  'community/create-community',
  async (params: ICreateCommunityParams) => {
    try {
      const response = await rf
        .getRequest('CommunityRequest')
        .createCommunity(params);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const updateCommunity = createAsyncThunk(
  'community/update-community',
  async (params: ICreateCommunityParams) => {
    try {
      const response = await rf
        .getRequest('CommunityRequest')
        .updateCommunity(params.id, params);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const deleteCommunity = createAsyncThunk(
  'community/delete-community',
  async (id: number) => {
    try {
      const response = await rf
        .getRequest('CommunityRequest')
        .deleteCommunity(id);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const getCommunities = createAsyncThunk(
  'community/get-community',
  async (params: IPagination) => {
    try {
      const response = await rf
        .getRequest('CommunityRequest')
        .getCommunities(params);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const getAllCommunity = createAsyncThunk(
  'community/get-all-community',
  async () => {
    try {
      const response = await rf
        .getRequest('CommunityRequest')
        .getAllCommunity();
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
);
